<div class="modal-header">
  <div class="display-flex-space-between flex-align-center">
    <h4>{{ 'Generic.Employees' | translate }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div class="modal-body">
  <input
    type="text"
    class="form-control"
    (keyup)="filter()"
    [(ngModel)]="searchText"
  />

  <div id="employeesList">
    <div
      style="cursor: default"
      class="optionContainer"
      *ngFor="let item of employeesFiltered"
    >
      <div
        class="display-flex-space-between flex-align-center optionContainerTop background2"
      >
        <div class="display-flex-left flex-align-center">
          <img
            class="categoryImg"
            draggable="false"
            [src]="
              coreService.getImageURL(item.Picture, 'assets/images/user.jpeg')
            "
          />
          <div style="width: 10px"></div>
          <div class="text-left">
            <div class="name text-bold">{{ item.itemName }}</div>
            <div class="team text-bold">{{ item.Team | uppercase }}</div>
            <div class="location">{{ item.Location }}</div>
          </div>
        </div>
        <a
          href=""
          [routerLink]="['/User/story']"
          [queryParams]="{ idVisitor: item.Id }"
          (click)="bsModalRef.hide()"
        >
          <i
            class="fa fa-user pointer background3-fontcolor"
            [attr.title]="'Messages.GoToProfile' | translate"
          ></i>
        </a>
      </div>
      <div
        class="display-flex-space-between flex-align-center optionContainerBottom"
      >
        <i
          class="patpat-icon icon-logo pointer"
          *ngIf="item.ReceivePat && userInfo.hasPatFeed"
          (click)="getNewPat(item)"
          [attr.title]="'GIVE_A_PAT' | translate"
        ></i>
        <i
          class="fa fa-pencil-square-o pointer"
          *ngIf="item.ReceiveFeedback && userInfo.hasEvaluationFeed"
          (click)="getNewEvaluation(item)"
          [attr.title]="'GIVE_FEEDBACK' | translate"
        ></i>
        <i
          class="fa fa-database pointer"
          *ngIf="
            item.ReceiveToken &&
            userInfo.hasTokenFeed &&
            userInfo.availableTokens >= 0
          "
          (click)="getTokenPopUp(item)"
          [attr.title]="'GIVE_TOKENS' | translate"
        ></i>
      </div>
    </div>
  </div>
</div>
